import { render } from "./ConcentrationWarning.vue?vue&type=template&id=d4ee5a20"
import script from "./ConcentrationWarning.vue?vue&type=script&lang=js"
export * from "./ConcentrationWarning.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__